import React, { useState } from "react";

const sections = [
  {
    icon: "🤝",
    title: "Quienes somos",
    content: `Yad2Yad es un marketplace exclusivo para miembros de la comunidad judia. Nuestra plataforma conecta compradores y vendedores dentro de la comunidad, facilitando transacciones seguras y de confianza entre sus miembros.

Todos los usuarios son verificados y aprobados manualmente por los administradores antes de poder operar en la plataforma.`,
  },
  {
    icon: "📦",
    title: "Productos nuevos y usados",
    content: `En Yad2Yad se pueden publicar tanto productos nuevos como usados. Es responsabilidad del vendedor describir con honestidad el estado del producto.

⚠️ Importante para compradores: Antes de confirmar una compra, te recomendamos:
- Leer detenidamente la descripcion del producto
- Revisar todas las fotos disponibles
- Consultar al vendedor por el chat interno ante cualquier duda
- Preguntar sobre el estado real del producto, uso previo, defectos o detalles importantes

Una vez confirmada la compra, se considera que el comprador acepto las condiciones descritas por el vendedor.`,
  },
  {
    icon: "💬",
    title: "Comunicacion entre usuarios",
    content: `Toda comunicacion entre compradores y vendedores debe realizarse exclusivamente a traves del chat interno de Yad2Yad.

Queda estrictamente prohibido:
- Compartir numeros de telefono o WhatsApp
- Compartir direcciones fisicas
- Coordinar operaciones por fuera de la plataforma

Esta politica existe para proteger a todos los miembros de la comunidad y garantizar que las transacciones queden registradas.`,
  },
  {
    icon: "💳",
    title: "Sistema de pagos",
    content: `Los pagos se realizan a traves de Mercado Pago, el unico medio de pago aceptado en la plataforma.

El dinero es retenido por Yad2Yad hasta que el comprador confirme la recepcion del producto mediante el codigo de entrega unico.

Una vez confirmada la entrega:
- El vendedor recibe el 95% del valor de venta
- Yad2Yad retiene el 5% como comision por el servicio
- Las primeras 2 ventas de cada vendedor no tienen comision`,
  },
  {
    icon: "🔑",
    title: "Codigo de entrega",
    content: `Al realizar una compra, el comprador recibe un codigo unico de 6 digitos.

Como funciona:
1. El comprador recibe el codigo por email y en la seccion "Mis compras"
2. Al momento de recibir el producto, el vendedor le solicita el codigo
3. El comprador muestra el codigo SOLO cuando tiene el producto en mano
4. El vendedor ingresa el codigo en la plataforma
5. La entrega queda confirmada y el pago se libera automaticamente

⚠️ No compartas el codigo antes de recibir el producto.`,
  },
  {
    icon: "⭐",
    title: "Sistema de reputacion",
    content: `Despues de cada compra confirmada, el comprador puede calificar al vendedor con una puntuacion de 1 a 5 estrellas y dejar un comentario.

Las calificaciones son publicas y visibles en los productos del vendedor. Esto ayuda a mantener la confianza dentro de la comunidad.

Yad2Yad se reserva el derecho de suspender usuarios con calificaciones repetidamente negativas o comportamientos inapropiados.`,
  },
  {
    icon: "📢",
    title: "Publicidad en la plataforma",
    content: `Los negocios de la comunidad pueden publicitar sus productos y servicios en Yad2Yad.

Condiciones:
- El costo es de $150.000 por mes de publicidad activa
- La publicidad debe ser aprobada por los administradores antes de activarse
- En caso de rechazo, el pago es devuelto en su totalidad
- Yad2Yad se reserva el derecho de rechazar publicidades que no sean apropiadas para la comunidad`,
  },
  {
    icon: "🔐",
    title: "Privacidad y seguridad",
    content: `Yad2Yad protege la privacidad de sus usuarios:
- Las contrasenas se almacenan encriptadas
- Los datos personales no son compartidos con terceros
- La plataforma no expone datos de contacto entre usuarios

El acceso a la plataforma requiere un codigo de invitacion y la aprobacion manual de los administradores, garantizando que todos los miembros pertenezcan a la comunidad.`,
  },
  {
    icon: "⚖️",
    title: "Responsabilidades",
    content: `Yad2Yad actua como intermediario entre compradores y vendedores. La plataforma no es responsable por:
- La calidad o estado real de los productos publicados
- Disputas entre compradores y vendedores sobre el estado de un producto
- Perdidas o danos durante el envio

Es responsabilidad del vendedor:
- Describir honestamente sus productos
- Entregar el producto en las condiciones descritas
- Coordinar la entrega de forma responsable

Es responsabilidad del comprador:
- Informarse bien antes de comprar
- Usar el chat para resolver dudas
- Confirmar la entrega solo cuando este conforme con el producto recibido`,
  },
  {
    icon: "🚫",
    title: "Productos prohibidos",
    content: `Queda prohibida la publicacion de:
- Productos ilegales o falsificados
- Medicamentos o sustancias controladas
- Armas o elementos peligrosos
- Productos que violen derechos de autor
- Contenido inapropiado para la comunidad

El incumplimiento de estas normas resultara en la suspension permanente de la cuenta.`,
  },
  {
    icon: "📋",
    title: "Modificaciones",
    content: `Yad2Yad se reserva el derecho de modificar estos terminos y condiciones en cualquier momento. Los cambios seran notificados a los usuarios y entraran en vigencia al momento de su publicacion.

El uso continuo de la plataforma implica la aceptacion de los terminos vigentes.

Para consultas o reclamos, comunicate con los administradores a traves de la plataforma.`,
  },
];

export default function Terms() {
  const [open, setOpen] = useState(null);

  return (
    <div style={s.page}>
      <div style={s.hero}>
        <h1 style={s.heroTitle}>Terminos y Condiciones</h1>
        <p style={s.heroSub}>Yad2Yad • Marketplace de la Comunidad Judia</p>
        <p style={s.heroDate}>Ultima actualizacion: Junio 2025</p>
      </div>

      {/* Aviso importante */}
      <div style={s.alert}>
        <span style={{fontSize:24}}>⚠️</span>
        <div>
          <p style={s.alertTitle}>Importante antes de comprar</p>
          <p style={s.alertText}>
            Yad2Yad permite la venta de productos nuevos y usados. Antes de confirmar cualquier compra, asegurate de leer bien la descripcion, ver todas las fotos y consultar al vendedor por el chat si tenes alguna duda. Una vez confirmada la compra, se considera que aceptaste las condiciones del producto.
          </p>
        </div>
      </div>

      {/* Secciones acordeon */}
      <div style={s.sections}>
        {sections.map((sec, i) => (
          <div key={i} style={s.section}>
            <button style={s.sectionHeader} onClick={() => setOpen(open===i ? null : i)}>
              <div style={s.sectionLeft}>
                <span style={s.sectionIcon}>{sec.icon}</span>
                <span style={s.sectionTitle}>{sec.title}</span>
              </div>
              <span style={s.chevron}>{open===i ? "▲" : "▼"}</span>
            </button>
            {open === i && (
              <div style={s.sectionContent}>
                {sec.content.split("\n").map((line, j) => (
                  <p key={j} style={{
                    ...s.contentLine,
                    ...(line.startsWith("•") ? s.bullet : {}),
                    ...(line.startsWith("⚠️") ? s.warning : {}),
                    ...(line.match(/^\d\./) ? s.numbered : {}),
                  }}>
                    {line}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={s.footer}>
        <p style={s.footerText}>
          Al usar Yad2Yad, confirmas que leiste y aceptas estos terminos y condiciones.
        </p>
        <p style={s.footerSub}>יד לָיָד • Comunidad Judia</p>
      </div>
    </div>
  );
}

const s = {
  page:{maxWidth:780,margin:"0 auto",padding:"0 16px 48px"},
  hero:{background:"linear-gradient(135deg,#0F6E56,#1D9E75)",borderRadius:"0 0 24px 24px",padding:"48px 32px",textAlign:"center",color:"#fff",marginBottom:24},
  heroTitle:{fontSize:"clamp(24px,5vw,36px)",fontWeight:700,marginBottom:8},
  heroSub:{fontSize:16,opacity:0.9,marginBottom:4},
  heroDate:{fontSize:13,opacity:0.7},
  alert:{background:"#fff8e1",border:"1.5px solid #f0c040",borderRadius:14,padding:"20px 24px",marginBottom:24,display:"flex",gap:16,alignItems:"flex-start"},
  alertTitle:{fontSize:15,fontWeight:700,color:"#b7830a",marginBottom:6},
  alertText:{fontSize:14,color:"#666",lineHeight:1.6},
  sections:{display:"flex",flexDirection:"column",gap:8},
  section:{background:"#fff",border:"0.5px solid #e0e0e0",borderRadius:12,overflow:"hidden"},
  sectionHeader:{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 20px",background:"none",border:"none",cursor:"pointer",textAlign:"left"},
  sectionLeft:{display:"flex",alignItems:"center",gap:12},
  sectionIcon:{fontSize:22},
  sectionTitle:{fontSize:15,fontWeight:600,color:"#111"},
  chevron:{fontSize:12,color:"#aaa"},
  sectionContent:{padding:"0 20px 20px 54px",borderTop:"0.5px solid #f0f0f0",paddingTop:16},
  contentLine:{fontSize:14,color:"#555",lineHeight:1.7,marginBottom:4},
  bullet:{paddingLeft:8,color:"#444"},
  warning:{color:"#b7830a",fontWeight:500,background:"#fff8e1",padding:"8px 12px",borderRadius:8,marginTop:8,marginBottom:8},
  numbered:{color:"#0F6E56",fontWeight:500},
  footer:{textAlign:"center",marginTop:40,padding:"24px",background:"#f9f9f9",borderRadius:14},
  footerText:{fontSize:14,color:"#555",marginBottom:8},
  footerSub:{fontSize:13,color:"#1D9E75",fontWeight:600},
};
